import { useEffect, useState } from "react";
import TekoID from "teko-oauth2";

export interface IAppSwitcherItem {
  appUrl: string;
  description: string;
  iconUrl: string;
  id: number;
  name: string;
}

const getAuthorization = () => {
  return TekoID.user?.isLoggedIn()
    ? `Bearer ${TekoID.user?.getAccessToken()}`
    : "";
};

const useAppSwitcher = (
  domain: string
): {
  appSwitcherItems: IAppSwitcherItem[];
  isFetching: boolean;
} => {
  const [appSwitcherItems, setAppSwitcherItems] = useState<IAppSwitcherItem[]>(
    []
  );
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (domain) {
        setIsFetching(true);
        try {
          const response = await fetch(`${domain}/api/v1/app-switcher`, {
            headers: {
              Authorization: getAuthorization(),
            },
          });
          const data = await response.json();
          setAppSwitcherItems(data.data?.switcherItems || []);
        } catch (error) {
          setAppSwitcherItems([]);
          console.log(error);
        } finally {
          setIsFetching(false);
        }
      }
    };

    fetchData();
  }, [domain]);

  return {
    appSwitcherItems,
    isFetching,
  };
};

export default {
  useAppSwitcher,
};
